/**
 * TableSkeleton — Skeleton de tabela
 */
import { SkeletonBar } from './SkeletonBar';
import { T } from '../../styles/tokens';

interface TableSkeletonProps {
  rows?: number;
  cols?: number;
}

export function TableSkeleton({ rows = 5, cols = 4 }: TableSkeletonProps) {
  return (
    <div>
      <div style={{ display: 'flex', gap: T.space4, padding: '12px 0', borderBottom: `1px solid ${T.border}` }}>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} style={{ flex: 1 }}><SkeletonBar height={11} width={`${60 + (i % 3) * 15}%`} /></div>
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ display: 'flex', gap: T.space4, padding: '14px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
          {Array.from({ length: cols }).map((_, c) => (
            <div key={c} style={{ flex: 1 }}><SkeletonBar height={14} width={`${50 + ((r + c) % 4) * 12}%`} /></div>
          ))}
        </div>
      ))}
    </div>
  );
}
